import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { Flex } from "sprout-ui-primitives";
import { markLabels, sortLabels } from "@sprout/client-lib/dist/labels_next";
import { ArrowBackIosOutlined } from "sprout-ui-icons";
import { Button } from "sprout-ui-dom/dist/Button";
import Dialog from "../Dialog";
import LabelsDialogInner from "./LabelsDialogInner";
import useAlterLabelsForItems from "./graphql/mutations/useAlterLabelsForItems";
const LabelsDialog = (props)=>{
    const { open , onRequestClose , labels , selectedItems , rootTopicId  } = props;
    const sortedLabels = useMemo(()=>sortLabels(labels), [
        labels
    ]);
    const markedLabels = useMemo(()=>markLabels(sortedLabels, selectedItems), [
        sortedLabels,
        selectedItems
    ]);
    const alterLabelsForItems = useAlterLabelsForItems(sortedLabels, selectedItems);
    const handleClose = useCallback(()=>{
        onRequestClose(new Error("Closing `LabelsDialog`"));
    }, [
        onRequestClose
    ]);
    return /*#__PURE__*/ _jsx(Dialog, {
        open: open,
        hideContextualActionBar: "desktop",
        contextualTitle: "Label this",
        onRequestClose: handleClose,
        leftAction: /*#__PURE__*/ _jsx(Button, {
            variant: "circle-bright-blue-bg",
            color: "white.100",
            onClick: handleClose,
            children: /*#__PURE__*/ _jsx(ArrowBackIosOutlined, {})
        }),
        children: /*#__PURE__*/ _jsx(Flex, {
            minHeight: "0",
            flexDirection: "column",
            px: 1,
            children: /*#__PURE__*/ _jsx(LabelsDialogInner, {
                rootTopicId: rootTopicId,
                labels: markedLabels,
                alterLabelsForItems: alterLabelsForItems,
                onRequestClose: onRequestClose
            })
        })
    });
};
export default LabelsDialog;
